/** 登录密码解密失败 **/
export const LOGIN_PWD_DECRYPT = 42200
/** 仪表盘(新)无权限 **/
export const SUMMARY_NO_PERMISSION = 42201
/** 客户年框申请、审核失败 **/
export const YEAR_FRAME_CUSTOMER = 4220
/** 集团年框申请、审核失败 **/
export const YEAR_FRAME_COMBINE = 4221